import {Injectable} from '@angular/core';

declare var NProgress: any;

@Injectable()
export class ProgressService {
    public inProgress: boolean;
    public isRoutingChangeInProgress: boolean

    constructor() {}

    startProgress(isRouting) {
        NProgress.start();
        this.inProgress = true;
        if (isRouting) {
            this.isRoutingChangeInProgress = true;
        }
    }

    stopProgress(isRouting) {
        NProgress.done();
        this.inProgress = false;
        if (isRouting) {
            this.isRoutingChangeInProgress = false;
        }
    }
}
